import React from 'react';
import Link from 'next/link';

const CustomLink = ({
	children, to, params, ...restProps
}) => {

	// Create Params
	const newParams = { ...params };

	// Open in new screen
	const newProps = { ...restProps };

	return (newParams ? (<Link
        href={{ pathname: to, query: { ...newParams } }}
        style={{ textDecoration: 'none', cursor: 'pointer' }}
        {...newProps}>

        {children}

    </Link>) : (<Link
        href={{ pathname: to }}
        style={{ textDecoration: 'none', cursor: 'pointer' }}>

        {children}

    </Link>));
};

export default CustomLink;
